export default "__VITE_ASSET__DdcY8BD4__"